import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { UsersInterFace } from '../models/users-interface';

import { ContactoInterface } from '../models/contacto-interface';
import { NoticiaInterface } from '../models/noticia-interface';
import { isNullOrUndefined } from 'util';

//remotoveneta.dyndns.org:5080
//http://localhost:8081

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  constructor(private http: HttpClient, private router: Router) { }
  headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept-Encoding':'gzip, deflate, br',

  });

  //Venetea
  setScroll(scroll)
  {
    localStorage.removeItem('scroll');
    localStorage.setItem('scroll', scroll);
  }
  getScroll()
  {
     return localStorage.getItem('scroll');
  }
   setNovedad(item)
  {
    localStorage.removeItem('item');

    localStorage.setItem('item',JSON.stringify(item) );
  }
  getNovedad()
  {
    return JSON.parse(localStorage.getItem('item'));
  }


  setNovedadesList(novedades)
  {
    localStorage.setItem('novedades',JSON.stringify(novedades));
  }
  


  // Guardar los datos en el Local Store del Navegado
  setUsers(user: UsersInterFace): void {
    const user_conect = JSON.stringify(user);
    localStorage.setItem('currentUsers', user_conect);
  }
  setToken(token): void {
    localStorage.setItem('accesToken', token);
  }
  setHora(hora): void {
    localStorage.setItem('accesHora', hora);
  }
  // Leer los datos del LocalStore
  getToken() {
    return localStorage.getItem('accesToken');
  }
  getHora() {
    return localStorage.getItem('accesHora');
  }


 
  /*LOGIN*/

  login(loginn) 
  {       
    const url = `http://remotoveneta.dyndns.org:5080/api/Login/InicioSesion`;
    return this.http
      .post<UsersInterFace>(
        url, loginn, { headers: this.headers }
      )
      .pipe(map(data => data));
  }

  setLogin(loginn)
  {

    localStorage.setItem('Login', loginn);
  }

   getLogin()
  {

    return localStorage.getItem('Login');
  }
  /*Noticias*/
  noticiaNew(Imagen,Titulo,Descripcion,Tipo,Fecha)
  {
       const url_api = `http://remotoveneta.dyndns.org:5080/api/Noticia/noticiaNew`;
       return this.http
      .post<NoticiaInterface>(url_api, { Imagen,Titulo,Descripcion,Tipo,Fecha}, { headers: this.headers })
      .pipe(map(data => data));
  }

  noticiaUpdate(Imagen,Titulo,Descripcion,Tipo,Fecha,Id_noticia)
  {
        const url_api = `http://remotoveneta.dyndns.org:5080/api/Noticia/actNoti`;       
        return this.http
        .post<NoticiaInterface>(url_api, {Imagen,Titulo,Descripcion,Tipo,Fecha,Id_noticia}, { headers: this.headers })
        .pipe(map(data => data));

  }



  getContactos()
  {
    const url_api = `http://remotoveneta.dyndns.org:5080/api/Contacto/getMensajes`;
    return this.http
      .get<ContactoInterface>(
        url_api, { headers: this.headers }
      )
      .pipe(map(data => data));
  }
  getNoticias()
  {
    /*const url_api = `http://localhost:8081/api/Noticia/getAll`;
    var Titulo = "";
    return this.http
      .post<NoticiaInterface>(url_api, { Titulo}, { headers: this.headers })
      .pipe(map(data => data));*/

       const url_api = `http://remotoveneta.dyndns.org:5080/api/Noticia/getAll`;
      return this.http
      .get<NoticiaInterface>(
        url_api, { headers: this.headers }
      )
      .pipe(map(data => data));
  }

  getNoticiasPortada()
  {
   const url_api = `http://remotoveneta.dyndns.org:5080/api/Noticia/get3`;
        return this.http
        .get<NoticiaInterface>(
          url_api, { headers: this.headers }
        )
        .pipe(map(data => data));

  }

  borrarNovedad(titulo,id_novedad)
  {
    const url_api = `http://remotoveneta.dyndns.org:5080/api/Noticia/borrarNoticia`;

    return this.http
      .post<NoticiaInterface>(url_api, {titulo, id_novedad}, { headers: this.headers })
      .pipe(map(data => data));

  }
  
  
  getFelly()
  {

   const url_api = `http://www.tokkobroker.com/api/v1/development/?key=d1fca3ce27c19afcbaa7d944bd5f06d7a6cb92b3`;
        return this.http
        .get(
          url_api, { headers: this.headers }
        )
        .pipe(map(data => data));
        
  }




  /****DINA****/

  getSeccion()
  {
     return localStorage.getItem('seccion');
  }
  setSeccion(sec)
  {
    localStorage.removeItem('seccion');
    localStorage.setItem('seccion', sec);
  }

  /*ENVIAR MENSAJE DE CONTACTO*/
  newContacto( Nombre, Email, Mensaje, Telefono) {         
    const url = `https://resellerdinabeat.com:4430/api/Contacto/MensajePatagoniaChain`;
    return this.http
      .post<ContactoInterface>(
        url, {Nombre,Email,Mensaje,Telefono}, { headers: this.headers }
      )
      .pipe(map(data => data));
  }


 setPortada(pais)
  {
    localStorage.removeItem('pais');
    localStorage.setItem('pais', pais);
  }

  getPais()
  {
     return localStorage.getItem('pais');
  }
  


}
